import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import Header from '../components/Header';
import Footer from '../components/Footer';
import styles from '../styles/test/TestStyles.module.css';

const NotFound = () => {
  return (
    <div className={styles.testPageContainer}>
      <div className="header-background" />
      <Header />
      <div className={styles.container}>
        <div className={styles.emptyState} style={{ textAlign: 'center', padding: '2rem' }}>
          <h1 style={{ fontSize: '4rem', margin: '0' }}>404</h1>
          <h2>Página no encontrada</h2>
          <p>Lo sentimos, la página que buscas no existe o ha sido movida.</p>
          <div style={{ marginTop: '2rem' }}>
            <Link to="/" style={{ marginRight: '1rem' }}>
              <Button variant="primary">
                Volver al inicio
              </Button>
            </Link>
            <Button
              variant="secondary"
              onClick={() => window.history.back()}
            >
              Volver atrás
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;